module.exports = __webpack_public_path__ + "static/media/DentalImageLarge.7aede35a.jpg";